import FileAction from '@/models/FileAction';
import FileType from '@/models/FileType';

const LOAD_FILE_RESOURCES = 'LOAD_FILE_RESOURCES';

const LOAD_FILE_RESOURCES_REQUEST = 'load_file_resources_request';
const LOAD_FILE_RESOURCES_SUCCESS = 'load_file_resources_success';
const LOAD_FILE_RESOURCES_ERROR = 'load_file_resources_error';

export { LOAD_FILE_RESOURCES };
/**
 * Loads and store the files-specific global data:
 * file_actions: the possible actions associated to a file
 * file_types: the possible types of documents uploaded.
 */
export default {
    state: {
        loading: false,
        file_actions: [],
        file_types: [],
    },
    mutations: {
        [LOAD_FILE_RESOURCES_REQUEST] (state) {
            state.loading = true;
        },
        [LOAD_FILE_RESOURCES_SUCCESS] (state, { file_actions, file_types }) {
            state.loading = false;
            state.file_actions = file_actions;
            state.file_types = file_types;
        },
        [LOAD_FILE_RESOURCES_ERROR] (state, errors) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_FILE_RESOURCES] ({ commit, state }) {
            commit(LOAD_FILE_RESOURCES_REQUEST);

            let fileActionsPromise = FileAction.collection();
            let fileTypesPromise = FileType.collection();

            Promise.all([fileActionsPromise, fileTypesPromise])
                .then(values => {
                    commit(LOAD_FILE_RESOURCES_SUCCESS, {
                        file_actions: values[0].items,
                        file_types: values[1].items,
                    });
                }).catch(({ status, errors }) => {
                    commit(LOAD_FILE_RESOURCES_ERROR, errors);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/file-resources.js